import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import About from "./About";
import Awards from "./Awards";
import Education from "./Education";
import Home from "./Home";
import Missions from "./Missions";
import Projects from "./Projects";
import Research from "./Research";
import Department from "./Department";
import Contact from "./Contact";
import Quotes from "./Quotes";
import Result from "./Result";
import EnrolledStudents from "./EnrolledStudents";
import Messages from "./Messages";
import Join from "./Join";
import PageNotFound from "./Requests/PageNotFound";
import OverseasEducation from "./OverseasEducation";
import Updates from "./Updates";
import Designations from "./Designations";
import EgyptEdu from "./eBranches/EgyptEdu";
import VTC from "./VTC";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Router>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/index" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/nfrac_projects" element={<Projects />} />
        <Route path="/nfrac_awards" element={<Awards />} />
        <Route path="/nfrac_missions" element={<Missions />} />
        <Route path="/nfrac_education" element={<Education />} />
        <Route path="/nfrac_education_usa" element={<OverseasEducation />} />
        <Route path="/nfrac_research_papers" element={<Research />} />
        <Route path="/department" element={<Department />} />
        <Route path="/contact_nfrac" element={<Contact />} />
        <Route path="/quotes" element={<Quotes />} />
        <Route path="/search-results" element={<Result />} />
        <Route path="/enrolled-students" element={<EnrolledStudents />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/join_nfrac" element={<Join />} />
        <Route path="/error" element={<PageNotFound />} />
        <Route path="/latest_notifications" element={<Updates />} />
        <Route path="/whoswho" element={<Designations />} />
        <Route path="/nfrac_education_egypt" element={<EgyptEdu />} />
        <Route path="/viswakarman_technological_center" element={<VTC />} />

      </Routes>
    </Router>
  </>
);
